import parse from "html-react-parser";

const QuoteBlockRender = ({ text }: { text: string })  => {
    return(
        <section className="mb-12">
            <div className="text-arcticMist font-extralight italic text-h4 leading-h4 [&>*]:mb-6">
                {text && parse(text)}
            </div>
        </section>
    )
}

export default QuoteBlockRender;